//--
import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';
//#reg

const CreatePetition = (data: any): Promise<any> =>
    request({
        url: ApiURL.Query.createPetitionRest,
        method: RequestType.POST,
        data,
    });
const CreatePetitionV2 = (data: any): Promise<any> =>
    request({
        url: ApiURL.Query.createPetitionV2,
        method: RequestType.POST,
        data,
        responseType: 'blob',
    });

const ExportSerbiaBankTxt = (data: { RefundIdList: number[] }): Promise<any> =>
    request({
        url: ApiURL.Query.exportSerbiaBankTxt,
        method: RequestType.POST,
        data,
        responseType: 'blob',
        skipBlobAutoOpen: true,
    });

const PetitionRefundlist = (data: any): Promise<any> =>
    request({
        url: ApiURL.Query.petitionrefundlist,
        method: RequestType.POST,
        data,
    });
const RefundHistory = (data: any): Promise<any> =>
    request({
        url: ApiURL.Query.refundHistory,
        method: RequestType.POST,
        data,
    });
const RefundList = (data: any): Promise<any> =>
    request({
        url: ApiURL.Query.refundList,
        method: RequestType.POST,
        data,
    });
const LcwMoneyCashRefund = (data: any): Promise<any> =>
    request({
        url: ApiURL.Query.lcwMoneyCashRefund,
        method: RequestType.POST,
        data,
    });
const PaymentList = (data: any): Promise<any> =>
    request({
        url: ApiURL.Query.paymentList,
        method: RequestType.POST,
        data,
    });
const GetRefundDetails = (data: any): Promise<any> =>
    request({
        url: ApiURL.Query.getRefundDetails,
        method: RequestType.POST,
        data,
    });
const GetAllRefundDetailsForOrder = (data: any): Promise<any> =>
    request({
        url: ApiURL.Query.getAllRefundDetailsForOrder,
        method: RequestType.POST,
        data,
    });

const DoRefundPendings = (data: any): Promise<any> =>
    request({
        url: ApiURL.Query.doRefundPendings,
        method: RequestType.POST,
        data,
    });
const PayBackList = (data: any): Promise<any> =>
    request({
        url: ApiURL.Query.paybackList,
        method: RequestType.POST,
        data,
    });
const GetRefundOfReturn = (data: any): Promise<any> =>
    request({
        url: ApiURL.Query.getRefundOfReturnForClient,
        method: RequestType.POST,
        data,
    });
const ConvertPaybackToLcwMoney = (data: any): Promise<any> =>
    request({
        url: ApiURL.Query.convertPaybackToLcwMoney,
        method: RequestType.POST,
        data,
    });

const UpdateWireCustomerChoice = (data: any): Promise<any> =>
    request({
        url: ApiURL.Query.updatewirecustomerchoice,
        method: RequestType.POST,
        data,
    });
const CheckOperatorFromRuleService = (): Promise<any> =>
    request({
        url: ApiURL.Query.checkOperatorFromRuleService,
        method: RequestType.GET,
    });

const ConvertPaybackToBankTransfer = (data: any): Promise<any> =>
    request({
        url: ApiURL.Query.convertPaybackToBankTransfer,
        method: RequestType.POST,
        data,
    });

const GetRefundMethodValidation = (params: any): Promise<any> =>
    request({
        url: ApiURL.Query.getRefundMethodValidation,
        method: RequestType.GET,
        params: params,
    });

const GetRefundPageRuleFromServiceForLcwMoney = (): Promise<any> =>
    request({
        url: ApiURL.Query.GetRefundPageRuleFromServiceForLcwMoney,
        method: RequestType.GET,
    });

const GetAkbankTransactionStatusList = (params: any): Promise<any> =>
    request({
        url: ApiURL.Query.getAkbankTransactionStatusList,
        method: RequestType.GET,
        params: params,
    });

const CheckPaymentConversionCloseRefundRole = (): Promise<boolean> =>
    request({
        url: ApiURL.Query.checkPaymentConversionCloseRefundRole,
        method: RequestType.GET,
    });

const GetRefundReceiptPdf = (data: { refundId: number | string; customerId: number | string }): Promise<any> =>
    request({
        url: ApiURL.Query.getRefundReceiptPdf,
        method: RequestType.POST,
        data: { refundId: Number(data.refundId), customerId: Number(data.customerId) },
        responseType: 'blob',
    });

const RefundRestQuery = {
    PetitionRefundlist,
    CreatePetition,
    RefundHistory,
    RefundList,
    LcwMoneyCashRefund,
    PaymentList,
    GetRefundDetails,
    GetAllRefundDetailsForOrder,
    DoRefundPendings,
    PayBackList,
    GetRefundOfReturn,
    ConvertPaybackToLcwMoney,
    UpdateWireCustomerChoice,
    CheckOperatorFromRuleService,
    CreatePetitionV2,
    ExportSerbiaBankTxt,
    ConvertPaybackToBankTransfer,
    GetRefundMethodValidation,
    GetRefundPageRuleFromServiceForLcwMoney,
    GetAkbankTransactionStatusList,
    CheckPaymentConversionCloseRefundRole,
    GetRefundReceiptPdf,
};

export default RefundRestQuery;
